import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  // mode: 'history', //修改打包
  routes: [{
    path: '/',
    redirect: '/login',
    icon: "el-icon-message-solid",// 图标样式class
    title: "登录",
  },
  // {
  //   path: '/',
  //   redirect: '/6',
  //   icon: "el-icon-message-solid",// 图标样式class
  //   title: "登录",
  // },
  // {
  //   path: '/',
  //   name: '6',
  //   meta: {
  //     title: '测试页面'
  //   },
  //   component: resolve => require(['../page/6.vue'], resolve),
  // },
  {
    path: '/',
    component: resolve => require(['../components/Home.vue'], resolve),
    meta: {
      icon: "el-icon-message-solid",// 图标样式class
      title: "菜单",
    },
    children: [
      {
        path: 'case',
        icon: "el-icon-message-solid",
        component: resolve => require(['../page/case.vue'], resolve),
        meta: {
          title: '终端查询'
        }
      },
      {
        path: 'file',
        component: resolve => require(['../page/file.vue'], resolve),
        meta: {
          title: '智能排班'
        }
      },
      {
        path: 'knowledget',
        component: resolve => require(['../page/knowledget.vue'], resolve),
        meta: {
          title: '数据采集'
        }
      },
      {
        path: 'administrators',
        component: resolve => require(['../page/administrators.vue'], resolve),
        meta: {
          title: '管理员信息'
        }
      },
      
      {
        path: 'options',
        name: '首页',
        meta: {
          title: '首页'
        },
        component: resolve => require(['../page/options.vue'], resolve),
      },

      {
        name: 'Character',
        path: 'Character',
        component: resolve => require(['../page/Character.vue'], resolve),
        meta: {
          title: '驾驶员账号'
        }
      }, 
      {
        path: 'weChatUser',
        name: 'weChatUser',
        meta: {
          title: '保险提醒'
        },
        component: resolve => require(['../page/weChatUser.vue'], resolve),
      },
      {
        path: 'VueEditor',
        name: 'VueEditor',
        meta: {
          title: '年检管理'
        },
        component: resolve => require(['../page/VueEditor.vue'], resolve),
      },
      {
        path: 'Dashboard',
        name: 'Dashboard',
        meta: {
          title: '任务列表'
        },
        component: resolve => require(['../page/Dashboard.vue'], resolve),
      },
      {
        path: '6',
        name: '6',
        meta: {
          title: '测试页面'
        },
        component: resolve => require(['../page/6.vue'], resolve),

      },
      {
        path: 'selection',
        name: 'selection',
        meta: {
          title: '新增选址'
        },
        component: resolve => require(['../page/selection.vue'], resolve),
      },
      {
        path: 'log',
        name: 'log',
        meta: {
          title: '终端列表'
        },
        component: resolve => require(['../page/log.vue'], resolve),
      },
      {
        path: 'Tabs',
        name: 'Tabs',
        meta: {
          title: '维修审核'
        },
        component: resolve => require(['../page/Tabs.vue'], resolve),
      },
      {
        path: 'driver',
        name: 'driver',
        meta: {
          title: '驾驶员信息'
        },
        component: resolve => require(['../page/driver.vue'], resolve),
      },
      {
        path: 'dataset',
        name: 'dataset',
        meta: {
          title: '数据统计'
        },
        component: resolve => require(['../page/dataset.vue'], resolve),
      },
      {
        path: 'alarm',
        name: 'alarm',
        meta: {
          title: '报警列表'
        },
        component: resolve => require(['../page/alarm.vue'], resolve),
      },
    ]
  },
  {
    path: '/login',
    component: resolve => require(['../page/login.vue'], resolve),
  },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js